import { Component, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';


@Component({
  selector: 'app-privacy-modal',
  templateUrl: './privacy-modal.component.html',
  styleUrl: './privacy-modal.component.css'
})
export class PrivacyModalComponent {
  testpop(){
    $('#myModal').css("display","block");
    $('#infoModal').css("display","block");
  }
  closeSecondModal(){
    $('#infoModal').css("display","none");
  }
  closeFirstModal(){
    $('#myModal').css("display","none");
  }
}
